
import "./PlusSign.scss";

export default function PlusSign() {
  return (
    <div className="plusSign">
        <span>+</span>
    </div>
  );
}
